export default {"src":"/_next/static/media/reach_logo_rgb_black.f2d48b19.svg","height":66,"width":296,"blurWidth":0,"blurHeight":0};